
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/creator-register",
      function () {
        return require("private-next-pages/auth/creator-register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/creator-register"])
      });
    }
  